var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FF003D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4953 32.3831L32.3873 20.3042H32.7475C33.2845 20.3042 33.7418 19.8895 33.7418 19.3099C33.7418 18.7703 33.2871 18.3156 32.7475 18.3156H30.7782L29.4217 15.9159C29.0298 15.3281 28.3262 14.9375 27.5826 14.9375H22.9384C22.1948 14.9375 21.4912 15.3282 21.0992 15.916L19.7428 18.3156H17.7736C17.194 18.3156 16.7793 18.773 16.7793 19.3099C16.7793 19.8869 17.1966 20.3042 17.7736 20.3042H18.0963L18.9882 32.3818L18.9883 32.3831C19.1049 33.7047 20.1565 34.6792 21.4796 34.6792H29.004C30.3272 34.6792 31.3787 33.7047 31.4953 32.3831ZM27.759 17.0228L28.3751 18.3156H22.1459L22.7505 17.0413C22.8048 16.926 22.8738 16.926 22.9384 16.926H27.5826C27.6548 16.926 27.7163 16.926 27.759 17.0228ZM20.976 32.2528L20.0855 20.3042H30.3982L29.5076 32.2528C29.4753 32.5019 29.2557 32.6906 29.004 32.6906H21.4796C21.228 32.6906 21.0084 32.5019 20.976 32.2528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.4c73dd2db420d061b67050580c324c9c.svg";
export { ForwardRef as ReactComponent };